
import styled from 'styled-components'

import FONTS from 'constants/fonts'
import COLORS from 'constants/colors'


import { Props } from './types'

export const TextAreaWrap = styled.div`
  display: block;
  position: relative;
`

export const TextAreaField = styled.textarea<Props>`
  font-size: ${FONTS.FONTINPUTS};
  max-width: 460px;
  min-height: 110px;
  display: block;
  border: ${(props: Props): string =>
    (!props.valid && props.touched && `1px solid ${COLORS.ERROR}`) ||
    (!props.valid && `1px solid ${COLORS.WARNING}`) ||
    '1px solid #999'};
  border-radius: 4px;
  box-shadow: inset 0px 1px 8px rgba(0, 0, 0, 0.2);
  width: 100%;
  padding: 10px;
  &:hover {
    box-shadow: inset 1px 2px 8px rgba(0, 0, 0, 0.02);
  }
  &:focus {
    color: #4b515d;
    border: 1px solid #b8b6b6;
    box-shadow: inset 1px 2px 4px rgba(0, 0, 0, 0.01),
      0px 0px 8px rgba(0, 0, 0, 0.2);
  }
`

export const Error = styled.span`
  color: ${COLORS.ERROR};
  position: absolute;
  bottom: -23px;
  left: 0;
`
